<div [ngStyle]="mapDivStyle()">
<div class='lgr_col'>
  <div class='lgr_10 col_01'><dynamic-field [id]='"scrndt"' [size]=10 [line]=1 [column]=1 [(ngModel)]='scrndt'></dynamic-field></div>
  <div class='lgr_40 col_20'><span class='brt high default' id='text1'>NATIONAL RAILROAD  PASSENGER CORPORATION</span>  </div>
  <div class='lgr_05 col_75'><span class='default' id='text2'>S144G</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><dynamic-field [id]='"scrntm"' [size]=8 [line]=2 [column]=1 [(ngModel)]='scrntm'></dynamic-field></div>
  <div class='lgr_34 col_23'><span class='brt high default' id='text3'>BUS ASSIGNMENTS MAINTENANCE SCREEN</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_40 col_20'><span class='brt high default' id='text4'>----------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text5'>ENTER REQUIRED FIELDS AND HIT APPROPRIATE FUNCTION KEY:</span>  </div>
</div>
<div class='lgr_col'>
  <div class='lgr_55 col_01'><span class='brt high default' id='text6'>-------------------------------------------------------</span>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_07 col_01'><span class='default' id='text7'>ORIGIN:</span>  </div>
  <div class='lgr_03 col_15'><dynamic-field [id]='"origin"' [size]=3 [line]=9 [column]=15 [(ngModel)]='origin'></dynamic-field></div>
  <div class='lgr_00 col_19'>  </div>
  <div class='lgr_07 col_30'><span class='default' id='text9'>DESTIN:</span>  </div>
  <div class='lgr_03 col_45'><dynamic-field [id]='"destin"' [size]=3 [line]=9 [column]=45 [(ngModel)]='destin'></dynamic-field></div>
  <div class='lgr_00 col_49'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_10 col_01'><span class='default' id='text11'>MOVE-ORIG:</span>  </div>
  <div class='lgr_03 col_15'><dynamic-field [id]='"mvorig"' [size]=3 [line]=11 [column]=15 [(ngModel)]='mvorig'></dynamic-field></div>
  <div class='lgr_00 col_19'>  </div>
  <div class='lgr_10 col_30'><span class='default' id='text13'>MOVE-DEST:</span>  </div>
  <div class='lgr_03 col_45'><dynamic-field [id]='"mvdest"' [size]=3 [line]=11 [column]=45 [(ngModel)]='mvdest'></dynamic-field></div>
  <div class='lgr_00 col_49'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_07 col_01'><span class='default' id='text15'>STATUS:</span>  </div>
  <div class='lgr_01 col_15'><dynamic-field [id]='"status"' [size]=1 [line]=13 [column]=15 [(ngModel)]='status'></dynamic-field></div>
  <div class='lgr_00 col_17'>  </div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_79 col_01'><dynamic-field [id]='"msgln"' [size]=79 [line]=22 [column]=1 [(ngModel)]='msgln'></dynamic-field></div>
</div>
<div class='lgr_col empty'>
</div>
<div class='lgr_col'>
  <div class='lgr_08 col_01'><span class='default' id='text17'>PF3=EXIT</span>  </div>
  <div class='lgr_10 col_12'><span class='default' id='text18'>PF4=RETURN</span>  </div>
  <div class='lgr_07 col_25'><span class='default' id='text19'>PF5=ADD</span>  </div>
  <div class='lgr_10 col_35'><span class='default' id='text20'>PF6=UPDATE</span>  </div>
  <div class='lgr_12 col_48'><span class='default' id='text21'>ENTER=SELECT</span>  </div>
</div>
</div>
